import React, { type ReactElement } from 'react';

import { RADIO_GROUP_CONST, type RadioGroupProps } from './RadioGroup.d';

const RadioGroupBase = ({ children, name, onChange, value, ...rest }: RadioGroupProps) => {
  const elements = React.Children.toArray(children).map((child, index) =>
    React.cloneElement(child as ReactElement, { name, key: index, onChange, selectedValue: value }),
  );

  return (
    <div data-testid={RADIO_GROUP_CONST.TEST_ID} {...rest}>
      {elements}
    </div>
  );
};

export default RadioGroupBase;
